import UserPermissionsConstants from 'app/shared/constants/UserPermissionsConstants';

const userUtils = {
    isRep(roles) {
        return roles.includes('rep');
    },
    isAdmin(roles) {
        return roles.includes('admin');
    },
    isPostingPathAdmin(roles = []) {
        if (roles === null) {
            return false;
        }

        return roles.includes('postingPathAdmin');
    },
    isRocketshipCustomer(roles = []) {
        return roles.includes('rocketShipCustomer');
    },
    isNucleusCustomer(roles = []) {
        return roles.includes('nucleusCustomer');
    },
    isSingleFamilyPayPerListingCustomer(roles = []) {
        return roles.includes('singleFamilyLegacyCustomer');
    },
    getFeaturePermissions(roles = []) {
        const enabledPermissions = {};
        const isAdmin = roles.includes(UserPermissionsConstants.PERMISSION_ROLES.COMPANY_ADMIN);
        for (const key of Object.keys(UserPermissionsConstants.PERMISSIONS)) {
            enabledPermissions[key] = isAdmin || roles.includes(UserPermissionsConstants.PERMISSION_ROLES[key]);
        }
        return enabledPermissions;
    },
};

export default userUtils;
